/**
 * Safely escape special HTML characters to prevent XSS and broken layout rendering.
 * @param {string} str - Raw input string
 * @returns {string} Escaped HTML string
 */
export function escapeHtml (str) {
  if (typeof str !== 'string') {
    return str ?? ''
  }
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}
